import React from "react";
import "./blog-card.css";

/**
 * Generic blog/post card component.
 *
 * Props:
 * - imageSrc: string (required) – URL for the card image
 * - imageAlt: string – alt text for the image
 * - category: string – small label at the top (e.g. "Education")
 * - title: string – main heading text
 * - onClick / href: optional – if provided, whole card becomes clickable
 */
export default function BlogCard({
  imageSrc,
  imageAlt = "",
  category = "",
  title = "",
  description = "",
  href,
  onClick,
}) {
  // When title is missing, use description as main heading
  const mainHeading = title || description || "";
  const showDescription = Boolean(title && description);

  const content = (
    <div className="blog-card">
      <div className="blog-card__image-wrapper">
        <img className="blog-card__image" src={imageSrc} alt={imageAlt} />
      </div>

      <div className="blog-card__content">
        <div className="blog-card__meta">
          {category && <div className="blog-card__category">{category}</div>}

          <div className="blog-card__heading-row">
            <div className="blog-card__title">{mainHeading}</div>
            <div className="blog-card__icon">
              {href ? (
                <a
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="blog-card__icon-link"
                  onClick={onClick}>
                  <img src="/arrow-up-right.png" alt="" className="blog-card__icon-img" />
                </a>
              ) : (
                <img src="/arrow-up-right.png" alt="" className="blog-card__icon-img" />
              )}
            </div>
          </div>

          {showDescription && <p className="blog-card__description">{description}</p>}
        </div>
      </div>
    </div>
  );

  if (onClick) {
    return (
      <button
        type="button"
        onClick={onClick}
        style={{
          border: "none",
          padding: 0,
          background: "transparent",
          cursor: "pointer",
        }}>
        {content}
      </button>
    );
  }

  return content;
}
